import { APIRoute } from '@/modules/utils'
import { PricePlan } from '@/data'
import { HydraCollection } from 'emt-library'

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/prices',
}

export type Response = HydraCollection<PricePlan>
